import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ProtectedRoute } from '@/components/auth';
import { Layout } from '@/components/layout';
import {
  LoginPage,
  DashboardPage,
  SearchPage,
  LowStockPage,
  NotFoundPage,
  UsersPage,
  DriverDashboardPage,
  TransferPage,
  CarsPage,
  ServicesPage,
  RegionsPage,
  ServiceManagementPage,
  RouteManagementPage,
  WinchPricingPage,
  WinchStartPointPage,
} from '@/pages';
import { ROUTES } from '@/utils/constants';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            {/* Redirect root to search */}
            <Route path="/" element={<Navigate to={ROUTES.SEARCH} replace />} />
            
            {/* Search - All roles */}
            <Route path={ROUTES.SEARCH} element={<SearchPage />} />
            
            {/* Dashboard - Accountant & Manager only */}
            <Route 
              path={ROUTES.DASHBOARD} 
              element={
                <ProtectedRoute allowedRoles={['accountant', 'manager']}>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Low Stock - Accountant & Manager only */}
            <Route 
              path={ROUTES.LOW_STOCK} 
              element={
                <ProtectedRoute allowedRoles={['accountant', 'manager']}>
                  <LowStockPage />
                </ProtectedRoute>
              } 
            />
            {/* Users - Manager only */}
            <Route
              path={ROUTES.USERS}
              element={
                <ProtectedRoute allowedRoles={['manager']}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />

            {/* Transfer - Manager only */}
            <Route
              path={ROUTES.TRANSFER}
              element={
                <ProtectedRoute allowedRoles={['manager']}>
                  <TransferPage />
                </ProtectedRoute>
              }
            />

            {/* Cars - All authenticated users */}
            <Route path={ROUTES.CARS} element={<CarsPage />} />

            {/* Services - All authenticated users */}
            <Route path={ROUTES.SERVICES} element={<ServicesPage />} />

            {/* Regions Management - Manager only */}
            <Route
              path={ROUTES.REGIONS}
              element={
                <ProtectedRoute allowedRoles={['manager']}>
                  <RegionsPage />
                </ProtectedRoute>
              }
            />

            {/* Service Management - Manager only */}
            <Route
              path={ROUTES.SERVICE_MANAGEMENT}
              element={
                <ProtectedRoute allowedRoles={['manager']}>
                  <ServiceManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Route Management - Manager only */}
            <Route
              path={ROUTES.ROUTE_MANAGEMENT}
              element={
                <ProtectedRoute allowedRoles={['manager']}>
                  <RouteManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Winch Pricing - All authenticated users */}
            <Route path={ROUTES.WINCH_PRICING} element={<WinchPricingPage />} />

            {/* Winch Start Points - Manager only */}
            <Route
              path={ROUTES.WINCH_START_POINTS}
              element={
                <ProtectedRoute allowedRoles={['manager']}>
                  <WinchStartPointPage />
                </ProtectedRoute>
              }
            />

            {/* Driver Dashboard - Driver role only */}
            <Route
              path="/driver-dashboard"
              element={
                <ProtectedRoute allowedRoles={['driver']}>
                  <DriverDashboardPage />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Toast Notifications */}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#2a2a2a',
            color: '#fff',
            border: '1px solid #444',
          },
          success: {
            iconTheme: {
              primary: '#FFC107',
              secondary: '#1a1a1a',
            },
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
